import api from "@/axios";
import type { AxiosResponse } from "axios";
import type { Order, CustomerOrderHistory } from "@/types/order-types";
import type {Product} from "@/types/order-types";

export const getOrders = async (): Promise<Order[]> => {
    const response = await api.get("/orders");
    return response.data;
}

export const addOrder = async (data: Order): Promise<any> => {
    const response = await api.post("/orders", data);
    return response.data;
}

export const getOrderById = async (id: string): Promise<Order> => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
}

export const editOrder = async (data: Order, id: string) => {
    const response = await api.put(`/orders/${id}`, data)
    return response.data
}

export const cancelOrder = async (orderId: string) => {
    const response = await api.patch(`/orders/${orderId}/cancel`)
    return response.data
}

export const uncancelOrder = async (orderId: string) => {
    const response = await api.patch(`/orders/${orderId}/uncancel`)
    return response.data
}

export const getCancelledOrders = async () => {
    const response = await api.get("/orders/cancelled")
    return response.data
}

export const getNextOrderNumber = async (): Promise<string> => {
    const response = await api.get("/orders/next-order-number");
    return response.data;
}

export const getOrderProductById = async (id: string): Promise<Product>=> {
    const response = await api.get(`/orders/products/${id}`)
    return response.data
}

export const getCustomerOrders = async (customerId: string): Promise<CustomerOrderHistory[]> => {
    const response = await api.get(`/orders/customers/${customerId}`)
    return response.data
}
